import { createFileRoute } from "@tanstack/react-router";

import { ReferralLanding } from "@/components/ReferralLanding";
import { utmSearch } from "@/lib/referral";

/** Link principal do revendedor: `/r/<codigo>?utm_source=...`. */
export const Route = createFileRoute("/r/$code/")({
  validateSearch: utmSearch,
  head: () => ({ meta: [{ title: "Monte seu uniforme — MonteBox" }] }),
  component: MainLink,
});

function MainLink() {
  const { code } = Route.useParams();
  return <ReferralLanding code={code} search={Route.useSearch()} />;
}
